// extracted by mini-css-extract-plugin
var _1 = "hSa1_SIoXWZ2cqveKmU_";
export { _1 as "action" }
export default { "action": _1 }
